<template>
  <div>
    <v-form enctype="multipart/form-data" ref="form" v-model="valid">
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <!-- Toolbar Header Principal -->
        <v-toolbar color="secondary" dark flat class="table-header-toolbar px-2 px-sm-3">
          <div class="d-flex align-center header-main-info flex-grow-1 min-width-0">
            <div class="header-icon-box mr-2 mr-sm-3 flex-shrink-0">
              <v-icon color="white">mdi-clipboard-text-outline</v-icon>
            </div>
            <div class="header-text-block min-width-0 mr-2 mr-sm-3">
              <div class="header-company-title font-weight-bold text-truncate">
                {{
                  Item.id == null ? "Registro de Inspección" : "Editar Inspección"
                }}
              </div>
            </div>
            <v-chip
              v-if="Item.id != null"
              small
              color="white"
              text-color="secondary"
              class="header-count-chip font-weight-bold elevation-1 flex-shrink-0"
            >
              <v-icon left size="15" color="secondary">mdi-pound</v-icon>
              ID: {{ Item.id }}
            </v-chip>
          </div>

          <div class="header-help-btn ml-1 ml-sm-2 flex-shrink-0">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-1 btn-circle-tooltip"
                  icon
                  dark
                  target="_blank"
                  :href="global.helpdesk_url + 'registra_inspeccion'"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon size="25" color="amber lighten-2"
                    >mdi-help-circle-outline</v-icon
                  >
                </v-btn>
              </template>
              <span>¿Necesitas ayuda?</span>
            </v-tooltip>
          </div>
        </v-toolbar>

        <v-card-text class="pa-3 pa-sm-4 pa-md-5">
          <!-- SECCIÓN 1: DATOS GENERALES -->
          <div class="section-title d-flex align-center mb-3">
            <v-icon color="secondary" small class="mr-2">mdi-domain</v-icon>
            <span class="text-subtitle-2 font-weight-bold text--primary">
              Datos del Cliente y Registro
            </span>
          </div>

          <v-row dense class="mb-3">
            <v-col cols="12" sm="6" md="4" class="pa-2">
              <v-text-field
                type="text"
                label="Código de inspección"
                v-model="Item.codigo"
                hide-details="auto"
                maxlength="10"
                @blur="onCodigoInspeccion"
                outlined
                dense
                prepend-inner-icon="mdi-barcode"
                placeholder="Opcional"
              ></v-text-field>
              <span
                class="red--text caption mt-1 d-block"
                v-if="mensajevalidacioncodigo"
              >
                {{ mensajevalidacioncodigo }}
              </span>
            </v-col>

            <v-col cols="12" sm="6" md="4" class="pa-2">
              <v-text-field
                type="text"
                label="Cliente"
                v-model="Cliente.razon_social"
                hide-details="auto"
                readonly
                required
                outlined
                dense
                prepend-inner-icon="mdi-domain"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4" class="pa-2">
              <v-text-field
                type="text"
                label="RUC"
                v-model="Cliente.ruc"
                hide-details="auto"
                readonly
                required
                outlined
                dense
                prepend-inner-icon="mdi-card-account-details"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- SECCIÓN 2: DATOS DEL VEHÍCULO Y LECTURA -->
          <div class="section-title d-flex align-center mb-3">
            <v-icon color="secondary" small class="mr-2">mdi-car-wrench</v-icon>
            <span class="text-subtitle-2 font-weight-bold text--primary">
              Información de la Inspección del Vehículo
            </span>
          </div>

          <v-row dense class="mb-3">
            <v-col cols="12" sm="6" md="3" class="pa-2">
              <v-autocomplete
                :items="Vehiculos"
                @change="onSeleccionarVehiculo"
                v-model="Item.id_vehiculo"
                label="Seleccionar vehículo *"
                dense
                outlined
                hide-details="auto"
                prepend-inner-icon="mdi-car"
                :rules="[(v) => !!v || 'Vehículo es requerido']"
              ></v-autocomplete>
              <div v-if="vehiculo.tipovehiculo" class="mt-1">
                <v-chip x-small color="info" class="font-weight-bold">
                  {{ vehiculo.tipovehiculo }}
                </v-chip>
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="3" class="pa-2">
              <v-text-field
                type="date"
                id="fecha_inspeccion"
                label="Fecha de inspección *"
                v-model="Item.fecha_inspeccion"
                hide-details="auto"
                :rules="[(v) => !!v || 'Fecha de inspección es requerido']"
                @change="onValidarDuplicidad(), onValidarFecha()"
                :disabled="Item.id_vehiculo == null"
                outlined
                dense
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
              <span
                class="red--text caption mt-1 d-block"
                v-if="mensajevalidacionfecha"
              >
                {{ mensajevalidacionfecha }}
              </span>
            </v-col>

            <v-col cols="12" sm="6" md="3" class="pa-2">
              <v-text-field
                type="number"
                label="Kilometraje/Horas Actual *"
                v-model="Item.km_inspeccion"
                hide-details="auto"
                :rules="[(v) => !!v || 'Km de inspección es requerido']"
                @change="onValidarDuplicidad(), onValidarKm()"
                :disabled="Item.id_vehiculo == null"
                outlined
                dense
                prepend-inner-icon="mdi-speedometer"
              ></v-text-field>
              <span
                class="red--text caption mt-1 d-block"
                v-if="mensajevalidacionkm"
              >
                {{ mensajevalidacionkm }}
              </span>
            </v-col>

            <v-col cols="12" sm="6" md="3" class="pa-2">
              <v-autocomplete
                :items="Plantas"
                v-model="Item.id_planta"
                label="Seleccionar Planta *"
                dense
                outlined
                hide-details="auto"
                prepend-inner-icon="mdi-factory"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <!-- SECCIÓN 3: EQUIPAMIENTO ADICIONAL -->
          <div class="section-title d-flex align-center mb-3">
            <v-icon color="secondary" small class="mr-2">mdi-tire</v-icon>
            <span class="text-subtitle-2 font-weight-bold text--primary">
              Equipamiento Adicional de la Unidad
            </span>
          </div>

          <v-row dense>
            <v-col cols="12" sm="6" class="pa-2">
              <v-sheet
                class="pa-3 rounded-lg border-subtle d-flex align-center justify-space-between flex-wrap gap-2"
                style="background-color: #f8fafc; border: 1px solid #e2e8f0"
              >
                <div>
                  <span
                    class="text-body-2 font-weight-medium text--primary d-block"
                  >
                    Llanta de Repuesto
                  </span>
                  <span class="caption grey--text"
                    >¿La unidad cuenta con llanta de repuesto?</span
                  >
                </div>
                <v-radio-group
                  inline
                  v-model="Item.repuesto"
                  row
                  hide-details
                  class="ma-0 pa-0"
                >
                  <v-radio label="Sí" :value="1" color="primary"></v-radio>
                  <v-radio label="No" :value="0" color="grey"></v-radio>
                </v-radio-group>
              </v-sheet>
            </v-col>

            <v-col cols="12" sm="6" class="pa-2">
              <v-sheet
                class="pa-3 rounded-lg border-subtle d-flex align-center justify-space-between flex-wrap gap-2"
                style="background-color: #f8fafc; border: 1px solid #e2e8f0"
              >
                <div>
                  <span
                    class="text-body-2 font-weight-medium text--primary d-block"
                  >
                    Porta Llanta
                  </span>
                  <span class="caption grey--text"
                    >¿La unidad tiene porta llanta instalado?</span
                  >
                </div>
                <v-radio-group
                  inline
                  v-model="Item.portallantas"
                  row
                  hide-details
                  class="ma-0 pa-0"
                >
                  <v-radio label="Sí" :value="1" color="primary"></v-radio>
                  <v-radio label="No" :value="0" color="grey"></v-radio>
                </v-radio-group>
              </v-sheet>
            </v-col>
          </v-row>

          <!-- Alerta de duplicidad -->
          <v-alert
            v-if="
              validacioncorrectaduplicidad &&
              mensajevalidacionduplicidad != 'Error de validación' &&
              mensajevalidacionfecha != 'Error de validación'
            "
            dense
            class="alerta-duplicidad mt-4 mb-0"
          >
            <template v-slot:prepend>
              <div class="alerta-duplicidad-badge mr-3">
                <v-icon color="#713F12" size="24">mdi-alert</v-icon>
              </div>
            </template>
            <div class="d-flex flex-column">
              <span class="alerta-duplicidad-titulo">
                Advertencia de Duplicidad
              </span>
              <span class="alerta-duplicidad-texto">
                {{ mensajevalidacionduplicidad }}
              </span>
            </div>
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <!-- Barra de Acciones -->
        <v-card-actions class="bg-actions pa-3 px-4 d-flex align-center form-card-actions">
          <v-spacer class="d-none d-sm-flex"></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            class="btn-form-action text-capitalize px-4 mr-sm-2"
            @click="cerrarModal()"
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn
            v-if="Item.id == null"
            color="primary"
            elevation="2"
            class="btn-form-action text-capitalize px-5"
            @click="openModalOpcionesParaGuardar()"
            :loading="loadingGuardarInspeccion"
            :disabled="loadingGuardarInspeccion"
          >
            <v-icon left small>mdi-content-save</v-icon>
            Guardar Inspección
          </v-btn>
          <v-btn
            v-else
            color="primary"
            elevation="2"
            class="btn-form-action text-capitalize px-5"
            @click="editar()"
            :loading="loadingGuardarInspeccion"
            :disabled="loadingGuardarInspeccion"
          >
            <v-icon left small>mdi-pencil</v-icon>
            Actualizar Inspección
          </v-btn>
        </v-card-actions>
      </v-card>

      <MensajeTransicion
        color="#FA694A"
        :text="mensaje"
        v-if="verAlerta && Item.id != null"
        :top="true"
        :bottom="false"
      />
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
// import axios from "axios";
import { axios2 as axios } from "@/interceptor/useApi";
import Alerta from "../alertas.vue";
import MensajeTransicion from "../Alerta.vue";
import global from "../../global";
import Swal from "sweetalert2";

export default {
  props: ["dialog", "Item", "Cliente", "Array_id_inspecciones"],
  components: {
    Alerta,
    MensajeTransicion,
  },
  data() {
    return {
      valid: false,
      loader: false,
      global: global,
      vehiculo: {
        id_vehiculo: null,
        tipovehiculo: "",
        id_configuracion: null,
        id_tipo: null,
      },
      mensajee: "",
      validacioncorrectafecha: false,
      validacioncorrectakm: false,
      validacioncorrectaduplicidad: false,
      mensajevalidacionduplicidad: false,
      mensajevalidacionfecha: "",
      mensajevalidacionkm: "",
      mensajevalidacioncodigo: "",
      dialogopcionesguardar: false,
      mensaje: "",
      verAlerta: false,
      loadingGuardarInspeccion: false,
      loadingGuardarInspeccionySalir: false,
    };
  },
  computed: {
    ...mapState("navigation", ["Permisos"]),
    ...mapState("inspeccion", ["Vehiculos", "Plantas"]),
    ...mapState("vehiculo", { VehiculoFind: "Item_vehiculo" }),
  },
  methods: {
    ...mapActions("inspeccion", [
      "cargarDatosAdicionales",
      "validarCodigo",
      "validarFecha",
      "validarKm",
      "validarDuplicidad",
    ]),
    ...mapActions("vehiculo", ["cargarVehiculosFind"]),

    onSeleccionarVehiculo: async function (id) {
      this.Item.id_vehiculo = id;
      if (id) {
        // Asignación sincrónica inmediata desde esta.Vehiculos
        this.Vehiculos.forEach((element) => {
          if (element.value == id) {
            this.vehiculo.id_vehiculo = id;
            this.vehiculo.id = id;
            this.vehiculo.tipovehiculo = element.tipovehiculo;
            this.vehiculo.id_configuracion = element.id_configuracion;
            this.vehiculo.id_tipo = element.id_tipo;
            this.Item.id_planta = element.id_planta;
          }
        });

        // Consulta asincrónica para obtener tipo_costo y complementar detalles de la API
        this.vehiculoLoadingPromise = (async () => {
          try {
            await this.cargarVehiculosFind({ id: id });
            let resData = this.VehiculoFind;
            if (resData && resData.data && Array.isArray(resData.data)) {
              resData = resData.data;
            }
            const vehData = Array.isArray(resData)
              ? resData.find((v) => v.id == id) || resData[0]
              : resData;
            if (vehData) {
              if (vehData.tipo_costo !== undefined) {
                this.vehiculo.tipo_costo = vehData.tipo_costo;
              }
              if (vehData.id_configuracion) {
                this.vehiculo.id_configuracion = vehData.id_configuracion;
              }
              if (vehData.id_tipo) {
                this.vehiculo.id_tipo = vehData.id_tipo;
              }
              if (vehData.id_planta && vehData.id_planta !== "-") {
                this.Item.id_planta = vehData.id_planta;
              }
            }
          } catch (error) {
            console.error("Error al ejecutar cargarVehiculosFind:", error);
          }
        })();
      }

      this.validacioncorrectafecha = false;
      this.validacioncorrectakm = false;
      this.mensajevalidacionfecha = "";
      this.mensajevalidacionkm = "";
      this.mensajevalidacioncodigo = "";
      //reiniciar valores
      this.Item.codigo = null;
      this.Item.repuesto = 0;
      this.Item.portallantas = 0;
      this.Item.fecha_inspeccion = null;
      this.Item.km_inspeccion = null;
      this.$refs.form.resetValidation();
      this.$emit("refrescar");
    },

    onCodigoInspeccion: async function () {
      if (this.Item.codigo != null && this.Item.codigo != "") {
        let existe = await this.validarCodigo(this.Item.codigo);
        if (existe == true) {
          this.mensajevalidacioncodigo =
            "El código de inspección ingresado ya se encuentra registrado";
        } else {
          this.mensajevalidacioncodigo = "";
        }
      }
    },

    onValidarDuplicidad: async function () {
      this.Item.fecha_inspeccion =
        document.getElementById("fecha_inspeccion").value;
      if (
        this.Item.fecha_inspeccion != null &&
        this.Item.fecha_inspeccion != "" &&
        this.Item.id_vehiculo != "" &&
        this.Item.km_inspeccion != "" &&
        this.Item.fecha_inspeccion != ""
      ) {
        this.$emit(
          "fechavalida",
          global._validar_fecha(this.Item.fecha_inspeccion),
        );

        let mensaje = await this.validarDuplicidad(this.Item);
        if (mensaje == "") {
          this.mensajevalidacionduplicidad = "";
          this.validacioncorrectaduplicidad = false;
        } else {
          this.mensajevalidacionduplicidad = mensaje;
          this.validacioncorrectaduplicidad = true;
        }
      } else {
        this.mensajevalidacionduplicidad = "";
        this.validacioncorrectaduplicidad = false;
      }
    },

    // emite cargarPosiciones cuando ambas validaciones son correctas
    async emitirCargarPosiciones() {
      if (this.vehiculoLoadingPromise) {
        await this.vehiculoLoadingPromise;
      }
      let datos = {
        vehiculo: {
          ...this.vehiculo,
          id_vehiculo:
            this.vehiculo.id_vehiculo ||
            this.vehiculo.id ||
            this.Item.id_vehiculo,
          id:
            this.vehiculo.id ||
            this.vehiculo.id_vehiculo ||
            this.Item.id_vehiculo,
        },
        inspeccion: this.Item,
      };
      this.$emit("cargarPosiciones", { ...datos });
    },

    onValidarFecha: async function () {
      this.validacioncorrectafecha = false;
      this.$emit("resetearUbicacion");
      const fechaEl = document.getElementById("fecha_inspeccion");
      if (fechaEl && fechaEl.value) {
        this.Item.fecha_inspeccion = fechaEl.value;
      }
      if (
        this.Item.fecha_inspeccion != null &&
        this.Item.fecha_inspeccion != ""
      ) {
        this.$emit(
          "fechavalida",
          global._validar_fecha(this.Item.fecha_inspeccion),
        );
        let resultado = await this.validarFecha(this.Item);
        if (!resultado.status) {
          this.mensajevalidacionfecha = resultado.message || "";
          this.validacioncorrectafecha = false;
        } else {
          this.mensajevalidacionfecha = "";
          this.validacioncorrectafecha = true;
          if (this.validacioncorrectakm) {
            await this.emitirCargarPosiciones();
          }
        }
      } else {
        this.mensajevalidacionfecha = "";
        this.validacioncorrectafecha = false;
      }
    },

    onValidarKm: async function () {
      this.validacioncorrectakm = false;
      this.$emit("resetearUbicacion");
      const fechaEl = document.getElementById("fecha_inspeccion");
      if (fechaEl && fechaEl.value) {
        this.Item.fecha_inspeccion = fechaEl.value;
      }
      const kmStr =
        this.Item.km_inspeccion != null
          ? String(this.Item.km_inspeccion).trim()
          : "";
      if (kmStr !== "" && !isNaN(parseInt(kmStr))) {
        let resultado = await this.validarKm(this.Item);
        if (!resultado.status) {
          this.mensajevalidacionkm = resultado.message || "";
          this.validacioncorrectakm = false;
        } else {
          this.mensajevalidacionkm = "";
          this.validacioncorrectakm = true;
          if (this.validacioncorrectafecha) {
            await this.emitirCargarPosiciones();
          }
        }
      } else {
        this.mensajevalidacionkm = "";
        this.validacioncorrectakm = false;
      }
    },

    openModalOpcionesParaGuardar: async function () {
      if (this.loadingGuardarInspeccion) return;
      //si la validación de fecha y km es correcta abrir modal
      if (this.$refs.form.validate()) {
        if (
          this.validacioncorrectafecha == true &&
          this.validacioncorrectakm == true
        ) {
          if (
            this.Array_id_inspecciones &&
            this.Array_id_inspecciones.length > 0
          ) {
            this.guardar("guardarYsalir");
          } else {
            this.verAlerta = true;
            this.mensaje = "No se ha registrado detalles en la inspección";
            setTimeout(() => [(this.verAlerta = false)], 4000);
          }
        } else {
          this.verAlerta = true;
          this.mensaje = "validación de fecha o kilometraje incorrecta";
          setTimeout(() => [(this.verAlerta = false)], 4000);
        }
      }
    },

    editar: async function () {
      if (this.loadingGuardarInspeccion) return;
      try {
        //si la validación de fecha y km es correcta editar
        if (
          this.validacioncorrectafecha == true &&
          this.validacioncorrectakm == true
        ) {
          this.loadingGuardarInspeccion = true;
          const url = "inspecciones/updateInspectionMinified";
          const data = {
            id_cliente: localStorage.getItem("idcliente"),
            id_usuario: localStorage.getItem("id"),
            identificador: this.Item.identificador,
            fecha_inspeccion: this.Item.fecha_inspeccion,
            vehiculo: this.Item.id_vehiculo,
            codigo: this.Item.codigo,
            km_inspeccion: this.Item.km_inspeccion,
            llantarepuesto: this.Item.repuesto,
            portallanta: this.Item.portallantas,
            id_planta: this.Item.id_planta,
          };

          await axios
            .post(url, data)
            .then((response) => {
              this.$emit("editarInspeccion", this.Item);
            })
            .catch((error) => {
              this.errorMessage = error.response ? error.response.data : error;
              console.error("error!", error);
              const msg =
                error.response?.data?.message ||
                error.response?.data?.error ||
                "Error al actualizar la inspección.";
              Swal.fire({
                icon: "error",
                title: "Error al actualizar",
                text: msg,
              });
            });
        } else {
          this.verAlerta = true;
          this.mensaje = "validación de fecha o kilometraje incorrecta";
          setTimeout(() => [(this.verAlerta = false)], 4000);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingGuardarInspeccion = false;
      }
    },

    guardar: async function (opcion) {
      if (this.loadingGuardarInspeccion) return;
      this.loadingGuardarInspeccion = true;

      try {
        const idsUnicos = [
          ...new Set(
            (this.Array_id_inspecciones || [])
              .map((item) =>
                typeof item === "object" && item !== null
                  ? item.id || item.id_inspeccion
                  : item,
              )
              .filter((item) => item != null && !isNaN(parseInt(item)))
              .map((item) => parseInt(item)),
          ),
        ];

        if (idsUnicos.length === 0) {
          Swal.fire({
            icon: "warning",
            title: "Sin inspecciones",
            text: "No se encontraron detalles de inspección válidos para finalizar.",
          });
          this.loadingGuardarInspeccion = false;
          return;
        }

        const url = "inspecciones/finishedInspectionSimplified";
        let id_planta = this.Item.id_planta == null ? "" : this.Item.id_planta;
        const data = {
          id_cliente: localStorage.getItem("idcliente"),
          id_usuario: localStorage.getItem("id"),
          fecha_inspeccion: this.Item.fecha_inspeccion,
          vehiculo: this.Item.id_vehiculo,
          codigo: this.Item.codigo,
          km_inspeccion: this.Item.km_inspeccion,
          llantarepuesto: this.Item.repuesto,
          portallanta: this.Item.portallantas,
          id_planta: id_planta,
          inspection_id: idsUnicos,
        };
        await axios
          .post(url, data)
          .then((response) => {
            this.$emit("guardarInspeccion", opcion);
          })
          .catch((error) => {
            this.errorMessage = error.response ? error.response.data : error;
            console.error("error!", error);
            const msg =
              error.response?.data?.message ||
              error.response?.data?.error ||
              "Ocurrió un error al finalizar la inspección. Verifique que los neumáticos sigan activos en el vehículo.";
            Swal.fire({
              icon: "error",
              title: "Error al guardar inspección",
              text: msg,
            });
          });
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingGuardarInspeccion = false;
      }
    },

    cerrarModal: function () {
      (this.validacioncorrectafecha = true),
        (this.validacioncorrectakm = true),
        (this.mensajevalidacionfecha = "");
      this.mensajevalidacionkm = "";
      this.mensajevalidacioncodigo = "";
      this.$emit("cerrarModalNuevo");
    },
  },

  watch: {
    // Puedes observar cambios en las props y actualizar el estado si es necesario
    Item() {
      (this.validacioncorrectafecha = true),
        (this.validacioncorrectakm = true),
        (this.mensajevalidacionfecha = "");
      this.mensajevalidacionkm = "";
      this.mensajevalidacioncodigo = "";
    },
  },
  created() {
    this.cargarDatosAdicionales();
  },
  mounted() {
    if (this.Item.id != null) {
      this.validacioncorrectafecha = true;
      this.validacioncorrectakm = true;
    }
  },
};
</script>

<style scoped>
/* Toolbar Header Responsive */
.table-header-toolbar {
  min-height: 56px;
}

.table-header-toolbar ::v-deep .v-toolbar__content {
  padding: 8px 14px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-main-info {
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
}

.header-icon-box {
  width: 38px;
  height: 38px;
  min-width: 38px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-text-block {
  min-width: 0;
  overflow: hidden;
}

.header-company-title {
  font-size: 1.1rem;
  line-height: 1.25;
  letter-spacing: 0.3px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-count-chip {
  font-size: 0.85rem !important;
  height: 28px !important;
}

.bg-actions {
  background-color: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.letra-11 {
  font-size: 11px;
}

.alerta-duplicidad {
  background: linear-gradient(135deg, #fef08a 0%, #fde047 100%) !important;
  border: 1.5px solid #eab308 !important;
  border-left: 6px solid #a16207 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 14px rgba(234, 179, 8, 0.3) !important;
  padding: 10px 14px !important;
  animation: fadeInAlert 0.25s ease-in-out;
}

.alerta-duplicidad ::v-deep .v-alert__wrapper {
  align-items: center;
}

.alerta-duplicidad-badge {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.85);
  border: 1.5px solid #ca8a04;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 2px 5px rgba(161, 98, 7, 0.18);
  margin: 8px !important;
}

.alerta-duplicidad-titulo {
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #854d0e !important;
  margin-bottom: 2px;
}

.alerta-duplicidad-texto {
  font-size: 0.94rem;
  font-weight: 700;
  color: #451a03 !important;
  line-height: 1.35;
}

@keyframes fadeInAlert {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .table-header-toolbar {
    min-height: 48px;
  }

  .table-header-toolbar ::v-deep .v-toolbar__content {
    padding: 6px 10px !important;
  }

  .header-icon-box {
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 6px;
  }

  .header-icon-box .v-icon {
    font-size: 18px !important;
  }

  .header-company-title {
    font-size: 0.88rem !important;
    line-height: 1.2;
  }

  .header-count-chip {
    font-size: 0.75rem !important;
    height: 24px !important;
    padding: 0 6px !important;
  }

  .header-count-chip .v-icon {
    font-size: 13px !important;
    margin-right: 2px !important;
  }

  .form-card-actions {
    flex-direction: column-reverse !important;
    align-items: stretch !important;
    gap: 8px !important;
    padding: 12px 14px !important;
  }

  .form-card-actions ::v-deep .v-btn,
  .form-card-actions .btn-form-action {
    width: 100% !important;
    max-width: 100% !important;
    display: flex !important;
    justify-content: center !important;
    margin: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .form-card-actions ::v-deep .v-btn + .v-btn {
    margin-left: 0 !important;
  }

  .alerta-duplicidad-badge {
    width: 34px;
    height: 34px;
    margin: 4px 8px 4px 0 !important;
  }

  .alerta-duplicidad-titulo {
    font-size: 0.72rem;
  }

  .alerta-duplicidad-texto {
    font-size: 0.84rem;
  }
}
</style>
